module.exports = __webpack_public_path__ + "img/udf-logo.f1d48c2d.png";